/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon16Solid = forwardRef('TextArticleTIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 1a1 1 0 0 0 0 2h1v3a1 1 0 0 0 2 0V3h1a1 1 0 0 0 0-2H2Z" }),
        React.createElement("path", { d: "M9 2a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H9Z" }),
        React.createElement("path", { d: "M8 6a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 8a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
});
